// extracted by mini-css-extract-plugin
export default {"footer":"ConfirmDialog_footer__TzKI5"};